import React, { useEffect, useState } from 'react'
import { MyModal } from '~/components/ui/MyModal'
import { Button, Form, Input, message } from 'antd'
import { MySelect } from '~/components/ui/MySelect'
import {
  enterpriseCategoryList,
  enterpriseCategoryList_itemModule_list,
  IntentionSubmitInput,
  submitIntention,
  submitIntentionVariables,
} from '~/graphqls/types'
import styles from './SubmitFormModal.module.css'
import { graphQLErrorMessage } from '~/utils'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { ENTER_PRISE_CATEGORY_LIST, SUBMIT_INTENTION } from '~/graphqls/gqls'
import { useMutation } from '@apollo/client'
import { MyIcon } from '../ui/MyIcon'

const SubmitFormModal: React.FC<{
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ visible, setVisible }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [industryList, setIndustryList] = useState<
    enterpriseCategoryList_itemModule_list[]
  >([])

  const industryListAction = useImperativeQuery<enterpriseCategoryList>(
    ENTER_PRISE_CATEGORY_LIST
  )

  const [submitAction] = useMutation<submitIntention, submitIntentionVariables>(
    SUBMIT_INTENTION
  )

  const onFinish = async (values: IntentionSubmitInput) => {
    try {
      if (!values) return
      setLoading(true)
      const res = await submitAction({
        variables: {
          input: values,
        },
      })
      if (res.data?.itemModule?.status) {
        message.destroy()
        message.success('提交成功')
      }
    } catch (err) {
      message.destroy()
      message.error(graphQLErrorMessage(err) || '提交失败')
    } finally {
      setLoading(false)
      setVisible(false)
    }
  }

  useEffect(() => {
    industryListAction().then(res => {
      setIndustryList(
        (res?.data?.itemModule
          ?.list as enterpriseCategoryList_itemModule_list[]) || []
      )
    })
  }, [])

  return (
    <MyModal
      open={visible}
      title={'商务咨询'}
      onCancel={() => setVisible(false)}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      width={704}
      footer={null}
      dark
      className={styles.submitFormModal}
    >
      <div className="text-neutral-400 text-xs mb-[26px]">
        请填写下列表单，方便我们了解你的情况，稍后会有商务专员联系您沟通具体事项
      </div>
      <Form name="submitForm" form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="personalName"
          label="姓名"
          rules={[{ required: true, message: '请输入姓名' }]}
        >
          <Input placeholder="请输入姓名" className={styles.input} />
        </Form.Item>
        <Form.Item
          name="mobile"
          label="手机号"
          rules={[{ required: true, message: '请输入手机号' }]}
        >
          <Input
            placeholder="请输入手机号"
            className={styles.input}
            maxLength={11}
          />
        </Form.Item>
        <div className="flex justify-between">
          <Form.Item
            name="industryCategoryId"
            label="行业"
            rules={[{ required: true, message: '请选择行业' }]}
          >
            <MySelect
              $dark
              placeholder="请选择行业"
              style={{ width: 314 }}
              getPopupContainer={(triggerNode: HTMLElement) =>
                triggerNode.parentNode as HTMLElement
              }
              dropdownStyle={{
                borderRadius: 12,
                background: '#23262F',
                padding: '8px 0',
              }}
              className={styles.select}
              suffixIcon={
                <MyIcon
                  icon="arrow-down-simple"
                  className="text-neutral-400 text-[24px]"
                ></MyIcon>
              }
            >
              {industryList.map(it => (
                <MySelect.Option value={it.id} key={it.id}>
                  {it.name}
                </MySelect.Option>
              ))}
            </MySelect>
          </Form.Item>
          <Form.Item name="companyName" label="公司（选填）">
            <Input
              placeholder="请输入公司名称（选填）"
              className={styles.input}
              style={{ width: 314 }}
            />
          </Form.Item>
        </div>
        <Button
          type="primary"
          className={styles.btn}
          onClick={() => form.submit()}
          loading={loading}
        >
          确认提交
        </Button>
      </Form>
    </MyModal>
  )
}
export default SubmitFormModal
